// extracted by mini-css-extract-plugin
module.exports = {"qaWrapper":"FAQ_qaWrapper__2w3bn","qaQuestion":"FAQ_qaQuestion__1B6j1","qaAnswer":"FAQ_qaAnswer__3IYeh","qaCard":"FAQ_qaCard__DAlyg","card":"FAQ_card__nyG6U"};